import { Check, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const DEPTS = [
  { code: "75", name: "Paris", slug: "paris-75" },
  { code: "92", name: "Hauts-de-Seine", slug: "hauts-de-seine-92" },
  { code: "93", name: "Seine-Saint-Denis", slug: "seine-saint-denis-93" },
  { code: "94", name: "Val-de-Marne", slug: "val-de-marne-94" },
  { code: "77", name: "Seine-et-Marne", slug: "seine-et-marne-77" },
  { code: "78", name: "Yvelines", slug: "yvelines-78" },
  { code: "91", name: "Essonne", slug: "essonne-91" },
  { code: "95", name: "Val-d'Oise", slug: "val-d-oise-95" },
];

const REASONS = [
  "Intervention rapide 30-45 min",
  "Disponibles 24h/24, 7j/7",
  "Tarifs clairs et sans surprise",
  "Professionnels expérimentés",
  "Matériel récent et adapté",
  "Assurance et sécurité garanties",
];

export default function ZonesSection() {
  return (
    <section className="bg-white py-16 lg:py-24" data-testid="zones-section">
      <div className="max-w-6xl mx-auto px-4 lg:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-extrabold text-txt-900">Zone d'intervention</h2>
          <p className="text-txt-500 mt-2">Nous intervenons dans toute l'Île-de-France, 24h/24 et 7j/7</p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          <div className="bg-ink-900 text-white rounded-2xl p-8 flex flex-col items-center justify-center text-center">
            <MapPin size={40} className="text-brand-300 mb-4" />
            <div className="text-5xl font-extrabold">8</div>
            <div className="text-lg font-bold mt-1">départements couverts</div>
            <div className="text-brand-300 text-sm mt-2">Toute l'Île-de-France</div>
          </div>

          <div>
            <h3 className="font-bold text-txt-900 mb-4 text-lg">Départements</h3>
            <ul className="space-y-2">
              {DEPTS.map((d) => (
                <li key={d.code}>
                  <Link to={`/departement/${d.slug}`} className="flex items-center gap-3 text-txt-700 hover:text-brand p-2 rounded-xl hover:bg-brand-50 transition-all">
                    <span className="w-9 h-9 rounded-lg bg-brand-50 text-brand flex items-center justify-center text-sm font-bold shrink-0">{d.code}</span>
                    <span className="font-medium text-sm">{d.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-txt-900 mb-4 text-lg">Pourquoi nous choisir ?</h3>
            <ul className="space-y-3">
              {REASONS.map((r) => (
                <li key={r} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-green-50 flex items-center justify-center shrink-0 mt-0.5">
                    <Check size={14} className="text-green-600" />
                  </div>
                  <span className="text-txt-700 text-sm">{r}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
